/**
 * Avatar utilities
 */

/**
 * Generates user avatar initials from a name
 * @param {string} name - The user's full name
 * @returns {string} The generated initials
 */
export const generateAvatarInitials = (name) => {
  if (!name) return '';
  
  const nameParts = name.split(' ').filter(part => part.length > 0);
  
  if (nameParts.length === 1 && nameParts[0].length >= 2) {
    // For single names, take first two letters
    return nameParts[0].substring(0, 2).toUpperCase();
  } else {
    // For multiple names, take first letter of each (up to 2 names)
    return nameParts
      .map(part => part[0].toUpperCase())
      .slice(0, 2)
      .join('');
  }
};
